<template>
    <div>
        <div class="ConetBox commonBox">
          <SuccesCase  :tableData="tableData"  v-if="CurrInt == 1"/>
          <ProTips :tableData="tableData"  v-if="CurrInt == 2 || CurrInt == 3"/>
          <el-pagination
            v-if="tableData.length>0"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage1"
            :page-size="10"
            layout="total, prev, pager, next"
            :total="20"
          >
          </el-pagination>
        </div>
        <Footer />
    </div>
</template>
<script>
import SuccesCase from "@/components/ListBox/SuccesCase.vue";
import ProTips from "@/components/ListBox/ProTips.vue";
export default {
    components:{
        SuccesCase,ProTips
    },
    data() {
      return {
        currentPage1: 5,
        MenuAct:'',
        CurrInt:1,
        tableData: [
        {
          jobName: "销售",
          companyName: "四川万象坤信科技有限公司",
          jobType: "全职",
          jobCount: "2",
          jobDate: "2016-05-02",
        }
      ],
      }
    },
    methods:{   
      GetNavClick(e){
        this.CurrInt = e;
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      }
    }
}
</script>
<style lang="scss">
.el-timeline{
  padding: 0;
}
  .bannerBox {
    height: 400px;
    .el-carousel__container {
      height: 100%;
    }
    .el-carousel__indicators--outside {
      position: absolute;
      bottom: 100px;
    }
    .el-carousel__item {
      img,
      .el-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  // ConetBox
  .ConetBox{
    p{
      text-indent: 40px;
      text-align: left;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 36px;
    }
    img{
      width: 100%;
    }
  }
</style>